import React from 'react'

import { Box, Typography } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    title: {
        fontWeight: 600,
    },
}))

export const ProspectsSectionHeader: React.FC = () => {
    const classes = useStyles()

    return (
        <Box className={classes.root}>
            <Typography variant="h5" className={classes.title}>
                Prospects
            </Typography>
        </Box>
    )
}
